var app = angular.module("leonardo");

var ReportsTemplateList = function($scope, $controller, $filter, $timeout, ReportService, LevelService, AuthDataService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Template Activity Reports');
  $scope.report_type = ReportService.TYPE_TEMPLATE;

  $scope.templateExpanded = null;
  $scope.levelService = LevelService;

  $scope.AuthDataService = AuthDataService;

  if ($scope.AuthDataService && $scope.AuthDataService.authData && $scope.AuthDataService.authData.account && $scope.AuthDataService.authData.account.country && $scope.AuthDataService.authData.account.country.code) {
    const code = $scope.country = $scope.AuthDataService.authData.account.country.code.toLowerCase();
    switch (code) {
      case "us":
        $scope.country = code;
        break;
      case "ca":
        $scope.country = code;
        break;
      case "uk":
        $scope.country = code;
        break;
      case "nl":
        $scope.country = code;
        break;
      default:
        $scope.country = 'us'
        break;
    }
  }

  $scope.getLevelName = function(report, level_type) {
    var name = '';
    angular.forEach(report.levels, function(level) {
      if (level.level_type === level_type) {
        name = level.name;
      }
    });
    return name;
  };

  $scope.templateIsExpanded = function(template) {
    return $scope.templateExpanded == template;
  };

  $scope.toggleGroup = function(group, event) {
    angular.element('body').addClass('block-ui-visible');
    angular.element('body').addClass('block-ui-active');
    $timeout(function() {
      $scope.groupExpanded = ($scope.groupExpanded == group) ? null : group;
      angular.element('body').removeClass('block-ui-visible');
      angular.element('body').removeClass('block-ui-active');
      $timeout(function() {
        angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: angular.element(event.target).offset().top - 120}, "slow");
      }, 0);
    }, 0);
  };

  $scope.toggleTemplate = function(template, event) {
    angular.element('body').addClass('block-ui-visible');
    angular.element('body').addClass('block-ui-active');
    $timeout(function() {
      $scope.templateExpanded = ($scope.templateExpanded == template) ? null : template;
      angular.element('body').removeClass('block-ui-visible');
      angular.element('body').removeClass('block-ui-active');
      $timeout(function() {
        angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: angular.element(event.target).offset().top - 120}, "slow");
      }, 0);
    }, 0);
  };

};

app.controller('ReportsTemplateList', ['$scope', '$controller', '$filter', '$timeout', 'ReportService', 'LevelService', 'AuthDataService',
  ReportsTemplateList]);
